export interface UserListApi {
  id: number
  name: string
  email: string
  phone: string
  code: string
  province: string
  postalcode: string
  verification: number
  status: number
}

export interface IUser {
  parent: any
  id: number
  name: string
  phone: string
  email: string
  role_id: number
  filterRoleId: number
  countries: number[]
  languages: number[]
  brands: number[]
  menus: number[]
  address: string
  country: any
  province: any
  town: any
  postalcode: any
  code: string
  client_type: null | number
  can_verify: number
  centerName: null | string
  centerAddress: null | string
  centerCountry: null | number
  centerProvince: null | number
  centerTown: null | number
  centerPostalcode: any
}

export type UserModalProps = {
  role_id: number
  showBotton?: boolean
}

export enum ROLES {
  superAdmin = 1,
  admin = 2,
  manager = 3,
  commercial = 4,
  trainingManager = 5,
  client = 6,
  trainer = 7,
  commercialC = 8,
  commercialD = 9
}

export enum VIP {
  Inactive = 0,
  Active = 1,
  Pending = 2,
  Denied = 3
}

export interface IBrand {
  id: number
  name: string
  vipStatus: number
  vipType: number
  brandLines: ILine[]
}

export interface ILine {
  id: number
  name: string
  vipStatus: number
  vipType: number
}
